



















import CrossPageTransition from '@/mixin/cross-page-transition'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class Complete extends Mixins<CrossPageTransition>(CrossPageTransition) {
  @Prop({ required: true })
  /**
   * 指定されるパスはSPA配下だけでなく、MPAのパスも指定される場合があり得る
   */
  readonly next: string

  goToNext() {
    this.goTo(this.next)
  }
}
